// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".sheet-tile{color:#1a1a1a;font-size:16px;grid-template-columns:8em 6em 8em 180px 1.5fr}.sheet-tile .address{color:#bcbcbc;font-size:16px}.sheet-tile .address .detail{font-size:16px;font-style:italic}", ""]);
// Exports
module.exports = exports;
